/** Parse student_logins_2026.csv (simple CSV, no embedded newlines). */
export function parseStudentLoginsCsv(text) {
  const lines = String(text || '')
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter(Boolean);
  if (lines.length < 2) return [];

  const headers = lines[0].split(',').map((h) => h.trim().toLowerCase());
  const idx = (name) => headers.indexOf(name);

  const rows = [];
  for (let i = 1; i < lines.length; i += 1) {
    const cols = lines[i].split(',').map((c) => c.trim());
    const get = (name) => {
      const j = idx(name);
      return j >= 0 ? cols[j] || '' : '';
    };
    const admno = get('admno');
    const name = get('name');
    const login_email = get('login_email');
    const password = get('password');
    if (!admno || !name || !login_email || !password) continue;
    rows.push({
      admno,
      name,
      class: get('class'),
      class_normalized: get('class_normalized'),
      login_id: get('login_id'),
      login_email,
      password,
      dob: get('dob'),
      active: get('active') || '1',
    });
  }
  return rows;
}

export function chunkArray(arr, size) {
  const out = [];
  for (let i = 0; i < arr.length; i += size) {
    out.push(arr.slice(i, i + size));
  }
  return out;
}
